import React from "react";
import utils from "./utils";
import classes from "./index.module.css";
import Button from "../../base-components/button";

const KycFail = () => {
  const onSubmit = () => {};
  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <h2 className={classes.Heading}>{utils.KYC_FAIL_HEADER}</h2>
        {utils.KYC_FAIL_SUBHEADINGS.map((subheading) => {
          return <p className={classes.SubHeading}>{subheading}</p>;
        })}
      </div>
      <div className={classes.middle}></div>
      <div className={classes.bottom}>
      </div>
    </div>
  );
};

export default KycFail;
